import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
  external?: boolean;
  className?: string;
}
export function CtaButton({
  href,
  children,
  size = 'md',
  external = false,
  className = ''
}: CtaButtonProps) {
  const base = 'inline-flex w-full items-center justify-center rounded-lg bg-accent font-display font-black uppercase leading-tight tracking-wide text-canvas text-center shadow-[0_6px_0_0_#c99a00] transition-colors duration-150 ease-soft hover:bg-accent-strong';
  const sizes: Record<string, string> = {
    md: 'px-4 py-3 text-sm',
    lg: 'px-5 py-3.5 text-base sm:text-lg'
  };
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : undefined} className={`${base} ${sizes[size]} ${className}`} data-id="element-184" data-mp="1d2n0dje33csy">
      {children}
    </a>;
}